'use client'

import Link from 'next/link'

export default function Footer() {
  return (
    <footer>
      {/* Ligne 1 : À propos + Contact (grille auto : s'adapte à 2 colonnes, empile sur mobile) */}
      <div
        className="footer-grid"
        style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))' }}
      >
        {/* Colonne 1 : À propos */}
        <div className="footer-section">
          <h4>Léna Lahor</h4>
          <p>
            Coach, thérapeute, conférencière à Lyon - Accompagner l'épanouissement
          </p>
          <p className="location-text">
            📍 Lyon 69002 - Quartier Confluence
          </p>
        </div>

        {/* Colonne 2 : Contact */}
        <div className="footer-section">
          <h4>Contact</h4>
          <div>
            <p style={{ marginBottom: '0.75rem' }}>
              <span className="contact-label">Téléphone</span>
              <a href="tel:+33619607081" className="contact-link">
                06 19 60 70 81
              </a>
            </p>

            <p style={{ marginBottom: '0.75rem' }}>
              <span className="contact-label">Email</span>
              <a href="mailto:contact@lena-lahor-coaching.fr" className="contact-link">
                contact@lena-lahor-coaching.fr
              </a>
            </p>

            <div style={{ marginBottom: 0 }}>
              <span className="contact-label">Adresse</span>
              <address className="contact-text" style={{ fontStyle: 'normal' }}>
                Rue denuzière<br />
                69002 Lyon<br />
                France
              </address>
            </div>
          </div>
        </div>
      </div>

      {/* Ligne 2 : liens de navigation (le maillage SEO détaillé est désormais dans le contenu des pages) */}
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '2rem 2rem 1rem',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
          gap: '2rem',
        }}
      >
        <div className="footer-section">
          <h4>Nos accompagnements</h4>
          <ul>
            <li><Link href="/hypnose">Hypnose maïeutique</Link></li>
            <li><Link href="/therapie">Accompagnement individuel</Link></li>
            <li><Link href="/motifs">Motifs de consultation</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Conférences et ateliers</h4>
          <ul>
            {/* À VÉRIFIER : page « Conférences » (hub) à confirmer */}
            <li><Link href="/conferences">Conférences parentalité</Link></li>
            <li><Link href="/conferences-entreprise-lyon">Conférences entreprise</Link></li>
            <li><Link href="/cercles">Ateliers et cercles</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Informations</h4>
          <ul>
            <li><Link href="/presentation">Présentation</Link></li>
            <li><Link href="/temoignages">Témoignages</Link></li>
            <li><Link href="/faq">FAQ</Link></li>
            <li><Link href="/contact">Contact</Link></li>
          </ul>
        </div>
      </div>

      {/* Bas du footer - Copyright centré + liens légaux en dessous */}
      <div className="footer-bottom">
        <p suppressHydrationWarning>© {new Date().getFullYear()} Accompagner l'épanouissement - Tous droits réservés</p>
        <div className="footer-legal">
          <Link href="/mentions-legales">Mentions légales</Link>
          <Link href="/politique-de-confidentialite">Politique de confidentialité</Link>
        </div>
      </div>
    </footer>
  )
}
